
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/location/add",
      function () {
        return require("private-next-pages/shop/location/add.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/location/add"])
      });
    }
  